import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Use a more flexible type that can accept any properties
interface RestaurantInfo {
  [key: string]: any; // This allows any key-value pairs from the backend
}

interface RestaurantStore {
  name: string;
  restaurant_info: RestaurantInfo | null;
  deliveryTime: string | number | null;
  orderPreparationTime: string | number | null;
  setName: (name: string) => void;
  setRestaurantInfo: (info: RestaurantInfo) => void;
  setDeliveryTime: (time: string | number | null) => void;
  setOrderPreparationTime: (time: string | number | null) => void;
  clearRestaurantInfo: () => void;
}

export const useRestaurantStore = create<RestaurantStore>()(
  persist(
    (set) => ({
      name: '',
      restaurant_info: null,
      deliveryTime: null,
      orderPreparationTime: null,
      setName: (name) => set({ name }),
      setRestaurantInfo: (info) =>
        set({
          restaurant_info: info,
          name: info.name || info.restaurant_name || '',
        }),
      setDeliveryTime: (time) => set({ deliveryTime: time }),
      setOrderPreparationTime: (time) => set({ orderPreparationTime: time }),
      clearRestaurantInfo: () =>
        set({
          restaurant_info: null,
          name: '',
          deliveryTime: null,
          orderPreparationTime: null,
        }),
    }),
    {
      name: 'restaurant-store', // Key for localStorage
      storage: {
        getItem: (name) => {
          const data = localStorage.getItem(name);
          return data ? JSON.parse(data) : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);
